import React from "react";

const refundcontent = () => {
  return (
    <section className="refund-content ">
      <div className="verification-wrap">
        <div className="refund-title all-one-title">Refund</div>

        <div className="fare-detail-content ">
          <div className="fare">Base fare</div>
          <div className="price">₹3,220 </div>
        </div>

        {/* <div className="fare-detail-content ">
          <div className="fare">Doorstep delivery & pickup</div>
          <div className="price">₹400 </div>
        </div> */}

        <div className="fare-detail-content ">
          <div className="fare">Insurance & GST</div>
          <div className="price">₹3,220</div>
        </div>

        <div className="fare-detail-content pending-refund ">
          <div className="fare ">Pending Refund</div>
          <div className="price ">₹0</div>
        </div>

        <div className="fare-detail-content  ">
          <div className="fare">
          <div>Citrus</div>
          <div className="initiate">Refund initiated and an amount of ₹ 5000 would reflect in your Citrus Wallet by Mon, 11 Jul 3:11</div>
          </div>
          <div className="price">₹5,000</div>
        </div>
      </div>
    </section>
  );
};

export default refundcontent;
